module.exports = __webpack_public_path__ + "assets/star-off-1ac8ba.svg";